import { ref } from 'vue';
import { usePaginationCore } from './usePaginationCore';

const DEFAULT_SIZE = 10;
const SIZES = Array.from({ length: 4 }, (_, index) => DEFAULT_SIZE + index * 10);

/**
 * PC端 分页器
 * @param {Object} options 配置选项
 * @returns {Object} PC端分页相关的响应式数据和方法
 */
export const usePaginationPC = (options = {}) => {
	const { defaultSize = DEFAULT_SIZE, sizes = SIZES, bindChange } = options;

	const pageSizes = ref(sizes);
	const pageLayout = ref('total, sizes, prev, pager, next, jumper');

	const pagination = usePaginationCore({
		defaultSize: defaultSize,
		bindChange
	});

	return {
		...pagination,
		pageSizes,
		pageLayout
	};
};
